import { render, staticRenderFns } from "./SmokingStatus.vue?vue&type=template&id=4ba05ed0"
import script from "./SmokingStatus.vue?vue&type=script&lang=js"
export * from "./SmokingStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports